module.exports = __webpack_public_path__ + "img/weflo.0236b151.png";